export default __webpack_public_path__ + "static/media/3 00_00_00-01_00_00.10aa9c9f.mp4";